import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { ArrowRight, ArrowLeft } from 'react-feather';

import { primaryButtonStyles } from './component-styles/button';
import { secondarylinkstyles, primarylinkstyles } from './component-styles/link';
import { animation } from '../styles';

const propTypes = {
  linkstyle: PropTypes.string,
  withArrow: PropTypes.bool,
  backArrow: PropTypes.bool,
  hoverUnderline: PropTypes.bool,
  children: PropTypes.any
};

const ExternalLink = props => {
  const {
    linkstyle = 'primary-link',
    withArrow = false,
    backArrow = false,
    hoverUnderline = false,
    children,
    ...allProps
  } = props;

  return (
    <StyledLink linkstyle={linkstyle} hoverUnderline={hoverUnderline} {...allProps}>
      {withArrow && backArrow && <LeftIcon size={20} />}
      {children}
      {withArrow && !backArrow && <RightIcon size={20} />}
    </StyledLink>
  );
};

const RightIcon = styled(ArrowRight)`
  margin-left: 8px;
  position: relative;
`;

const LeftIcon = styled(ArrowLeft)`
  margin-right: 8px;
  position: relative;
`;

const StyledLink = styled.a`
  ${({ linkstyle }) => {
    switch (linkstyle) {
      case 'button':
        return primaryButtonStyles;
      case 'primary-link':
        return primarylinkstyles;
      case 'secondary-link':
        return secondarylinkstyles;
      default:
        return primarylinkstyles;
    }
  }}

  svg {
    position: relative;
    transition: ${animation.general.transition};
  }

  &:hover {
    text-decoration: ${({ hoverUnderline }) => (hoverUnderline ? 'underline' : '')};

    ${LeftIcon} {
      transform: translateX(-2px);
    }

    ${RightIcon} {
      transform: translateX(2px);
    }
  }
`;

ExternalLink.propTypes = propTypes;

export { ExternalLink };
